export const TYPES = {
  SET_APP_VERSION: 'APPLICATION/SET_APP_VERSION',
  SET_PORTAL_CONFIG: 'APPLICATION/SET_PORTAL_CONFIG',
  SET_PORTAL_ABBR: 'APPLICATION/SET_PORTAL_ABBR',
  SET_PENDING: 'APPLICATION/SET_PENDING',
}
